import { Link } from "react-router-dom";

const announcements2024Array = [

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-24_18.pdf",
        title: "Advertisement for the Junior Research Fellow (JRF) position in the Department of Mechanical Engineering under CSRC (2023-24 #18)",
        modal: false,        
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-24_17.pdf",
        title: "Advertisement for the Junior Research Fellow (JRF) position in the Department of Chemical and Engineering under CSRC (2023-24 #17)",
        modal: false,        
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTP_RECT-OS202024_Notification.pdf",
        title: "Notification for Outsourced Position of Project Assistant for Electrical Engineering Department - #FESS/IITTP/RECT-OS/20/2024",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTP_RECT-OS202024_Notification.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTP_RECT-OS202024_Application.pdf",
        modal: false,
    },

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2501_7_8_24.pdf",
        title: "Advertisement for the post of Project Manager (Innovation, Incubation, IPR, Start up and Industrial relations) at Centre for Sponsored Research and Consultancy (CSRC)- IIT Tirupati.",
        modal: false,        
    },

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS192024_Notification.pdf",
        title: (<>Notification for Outsourced Position of Project Officer (Civil & Architect) - #ITTP/FESS/RECT-OS/19/2024 <br/><br/> (Last Date: 16-08-2024)<br/><br/></>),
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS192024_Notification.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS192024_Application_Form.pdf",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT-CSRC_2023-24_16.pdf",
        title: "Advertisement for the Junior Research Fellow (JRF) position in the Department of Computer Science and Engineering under CSRC (2023-24 #16)",
        modal: false,        
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS182024_Notification_CC.pdf",
        title: "Notification for Outsourced Position of Project Officer, Project Associate, Project Assistant - Computer Center Department",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS182024_Notification_CC.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS182024_Application_Form_CC.pdf",
        modal: false,
    },
   
    {
        link: "/information_for_btech_students",
        title: "Information for B.Tech 2024 Batch Students - Click here for more details",
        modal: false,
    },
    {
        
        link: "https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_MS_PhD_Jul_24.pdf",
        title: "Orientation Program for M.S.(R) / Ph.D. Scholars on July 25-26, 2024 - Click here",
        modal: false,
    },
    {
        
        link: "https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_Mtech_Msc_MPP_2024.pdf",
        title: "Orientation Program for M.Tech / M.Sc / MPP on July 26, 2024 - Click here",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS162024_Shortlisted_candidates_Junior_Executive.pdf",
        title: "Shortlisted Candidates List - Junior Executive - Academics (Outsourced Positions)",
        modal: false,
    },
    {
        
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2415.pdf",
        title: "Advertisement for the Junior Research Fellow (JRF) position in the Department of Mechanical Engineering under CSRC",
        modal: false,
    },
    {
        
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2413.pdf",
        title: "Advertisement for the Junior Research Fellow (JRF) position in the Department of Electrical Engineering under CSRC",
        modal: false,
    },
    {
        
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2514.pdf",
        title: "Advertisement for the Project Assistant Level 1 position in the Department of Computer Science and Engineering under CSRC",
        modal: false,
    },
    
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/IITT_SPORTS_02_COACH.AD_2024.pdf",
        title: "Notification for Engagement of Part-Time / Hourly Basis Coaches",
        modal: false,
    },
    {
        
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/CSRC_23-24_12.pdf",
        title: "Advertisement for the post of Project Engineer in the Department of Electrical Engineering under CSRC",
        modal: false,
    },
    {
        
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT_CSRC_2024-25_11.pdf",
        title: "Advertisement for the post of Project Associate in the Department of Electrical Engineering under CSRC",
        modal: false,
    },
    {
        link: "/convocation",
        title: "6th Convocation will be held on 21.07.2024 (Sunday) at IIT Tirupati campus - Click here for more details",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS172024_Notification.pdf",
        title: "Notification for Outsourced Position – Health Centre Assistant",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS172024_Notification.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS172024_Application_Form.pdf",
        modal: false,
    },
    {
        link: "/kvsiittcampus",
        title: "Walk-in-interview for part-time contractual teacher posts in KV School, IIT Tirupati campus - Click here",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2510.pdf",
        title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Physics",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2409_27_6_24.pdf",
        title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Civil and Environmental Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS152024_Notification.pdf",
        title: "Notification for Outsourced Position – Junior Executive - Academics",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS162024_Notification.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPFESSRECT-OS162024_Application_Form.pdf",
        modal: false,
    },
   
    {
        link: "/kvsiittcampus",
        title: "Admissions for the Vacant Seats in KV IIT Tirupati Campus for the Session 2024-2025",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSITTPRECT-OS132024_Selected_Candidates_New.pdf",
        title: "Selected Candidates List – Yoga Instructor (Outsourced Positions)",
        modal: false,
    },
    {
        link: "/kvsiittcampus",
        title: "Provisionally selected list of candidates for appointment of Contractual Teachers for 2024-2025",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2408.pdf",
        title: "Advertisement for Project Assistant-I position in the Department of Chemical Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS142024_Selected_List_Project_Assitant-Horticulture.pdf",
        title: "Selected Candidates List – Project Assistant (Horticulture - Outsourced Positions).",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS152024_Nursing_Practioner_Selected_List.pdf",
        title: "Selected Candidates List - Nursing Practitioner (Outsourced Positions)",
        modal: false,
    },
    {
        link: "/openhouse",
        title: "Open House - An Interactive Session for Prospective Students 2024",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2023-2407.pdf",
        title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemistry and Chemical Engineering",
        modal: false,
    },
    {
        link: "/msphd-admissions",
        title: "Selected Candidates List for Master of Public Policy (MPP) - Click here",
        modal: false,
    },
               
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2506.pdf",
        title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemical Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2505.pdf",
        title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Humanities and Social Sciences",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2504.pdf",
        title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Mechanical Engineering",
        modal: false,
    },
    
    {
        link: "https://files.iittp.ac.in/pdfs/msphd/admissions/2024/IITTP_2024-25_M.TechSponsored.pdf",
        title: "Selected Candidates List for M.Tech program under the Sponsored Category - Click here",
        modal: false,
    },
    {
        link: "/msphd-admissions",
        title: "Selected Candidates List for M.S.(Research) and Ph.D. Admissions July 2024 - Click here",
        modal: false,
    },
    {
        link: "/kvsiittcampus",
        title: "Walk-in-interview for part-time contractual teacher posts in KV School, IIT Tirupati campus - Click here",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSITTPRECT-OS142024_Shortlisted_Candidates.pdf",
        title: "Shortlisted Candidates List – Project Assistant (Horticulture - Outsourced Positions). Due to Administrative Reasons, Project Assistant - Horticulture exam was rescheduled on 10-06-2024",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Shortlisted_NURSING_PRACTITIONER.pdf",
        title: "Shortlisted Candidates List - Nursing Practitioner (Outsourced Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSITTPRECT-OS132024_Shortlisted_Candidates_New.pdf",
        title: "Shortlisted Candidates List – Yoga Instructor (Outsourced Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS152024_Notification.pdf",
        title: "Notification for Outsourced Position – Nursing Practitioner (Health Centre)",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS152024_Notification.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS152024_Application_Form.docx",
        modal: false,
    },
    {
        link: "/kvsiittcampus",
        title: "Provisionally Selected List of Candidates for Admissions during 2024-2025 in KV IITT - Click here",
        modal: false,
    },
   
    
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification_FESSIITTPRECT-OS142024.pdf",
        title: "Notification for Outsourced Position – Project Assistant (Horticulture)",
        notifyLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification_FESSIITTPRECT-OS142024.pdf",
        appLink: "https://files.iittp.ac.in/pdfs/announcements/2024/Application_Form_FESSIITTPRECT-OS142024.docx",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2503.pdf",
        title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemical Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Summer_Internship_Results.pdf",
        title: "Summer Internships Selected Candidates List - Click here",
        modal: false,
    },

    {
        link: "/m-tech-international",
        title: "M.Tech International Admissions 2024 are now open - Click here",
        modal: false,
    },
    
   
   
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2502_Updated.pdf",
        title: "Advertisement for Project Assistant position in the Department of Chemical Engineering - Last date extended up to 1st May, 2024",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS112024_Result-Nursing_Practitioner.pdf",
        title: "Selected Candidates List – Nursing Practitioner & Ward Assistant (Health Centre)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS122024_Result-MSA.pdf",
        title: "Selected Candidates List – Multi Skilled Assistant (Outsourced Positions)",
        notifyLink: "#",
        appLink: "#",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS072024_Selected_List-Academics.pdf",
        title: "Selected Candidates List – Junior Executive  - Academics (Outsourced Positions)",
        modal: false,
    },
   
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Summer_Internship_2024_Corrigendum.pdf",
        title: "SUMMER INTERNSHIPS CORRIGENDUM - Click here",
        modal: false,
    },
    {
        link: "/kvsiittcampus",
        title: "KVS, IITT Campus Admissions 2024-25 - Click here",
        modal: false,
    },
    
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Notification&Application_FESSIITTPRECT-OS132024.pdf",
        title: "Notification for Outsourced Position - Yoga Instructor (Part-time)",
        modal: false,
    },
    {
        link: "/admissions",
        title: "M. Tech. and MPP Admissions 2024 are now open - Click here",
        modal: false,
    },
    
    {
        link: "/recruitment",
        title: "Advertisement for various Non- Teaching Staff Positions(Regular)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSITTPRECT-OS122024_Shortlisted_Candidates.pdf",
        title: "Shortlisted Candidates List – Multi Skilled Assistant (Outsourced Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSITTPRECT-OS112024_Shortlisted_Candidates.pdf",
        title: "Shortlisted Candidates List – Nursing Practitioner & Ward Assistant (Health Centre)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/ITTPRECT-OS072023_Short_listed_Candidates.pdf",
        title: "Shortlisted Candidates List – Junior Executive, Academics (Outsourced Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2501.pdf",
        title: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemical Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT-CSRC-2023-24_29.pdf",
        title: "Advertisement for JRF position in the Department of Chemistry/Chemical engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/announcements/2024/FESSIITTP_RECT-OS112024_Notification.pdf",
        title: "Notification for Outsourced Position - Nursing Practitioner and Ward Assistant",
        modal: false,
    },

    {
        link: "https://files.iittp.ac.in/announcements/2024/FESSIITTP RECT-OS122024_Notification.pdf",
        title: "Notification for Outsourced Position - Multi Skilled Assistant", 
        modal: false,
    },

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT-CSRC-2023-24_31.pdf",
        title: "Advertisement for Project Assistant position in the Department of Computer Science and Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT-CSRC-2023-24_30.pdf",
        title: "Advertisement for SRF position in the Department of Computer Science and Engineering",
        modal: false,
    },
    {
        link: "/admissions",
        title: "Online applications open for M.S.(R) & Ph.D - July 2024 - Click here",
        modal: false,
    },

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2427.pdf",
        title: "Advertisement for JRF/Project Staff Position",
        modal: false,
    },

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS102024_Selected_List.pdf",
        title: "Selected Candidate List - Hindi Typist cum Assistant (Outsourced Positions)",
        modal: false,
    },

     {
         link: "https://files.iittp.ac.in/pdfs/announcements/2024/Internship_Notification_2024.pdf",
        title: "Notification for the Summer Internship (15th May to 14th July 2024) 2024 - Extension of online applications for summer internships upto 3rd april 2024, 5.00 pm.",
         modal: false,
     },

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS092024_Result-Physiotherapist.pdf",
        title: "Selected Candidate List - Physiotherapist(Outsourced Positions) ",
        modal: false,
    },

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2426.pdf",
        title: "Advertisement for the Position of Junior Research Fellow - Department of Chemical Engineering and Mechanical Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTPRECT-OS102024_Short%20listed_Candidates%20-%20Hindi_Typis_cum_Assistant.pdf",
        title: "Shortlisted Candidates List - Hindi Typist cum Assistant (Outsourced Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/IRES-2024_Indian_Student_Brochure.pdf",
        title: "USA-India International Research Experience for Students (IRES) - Indian Applicants",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2425.pdf",
        title: "Advertisement for the Position of Junior Research Fellow - Department of Physics (Last date extended up to 8th March, 2024)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTP%20RECT-OS092024_Short%20listed_Candidates_Physiotherapist.pdf",
        title: "Shortlisted Candidates List - Physiotherapist(Outsourced Positions)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/announcements#OP_HTA_2_9",
        title: "Notification for Outsourced Position - Hindi Typist cum Assistant",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2424.pdf",
        title: "Advertisement for the Positions of Junior Research Fellow - SERB Sponsored Project under CRG",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/FESSIITTP%20RECT-OS082023_Selected_List-EU.pdf",
        title: "Selected Candidates List - Engineering Unit (Outsourced Positions)",
        modal: false,
    },
    
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2418.pdf",
        title: "Advertisement for the Positions of Junior Research Fellow - Department of Electrical Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt%20IITTCSRC2023-2422.pdf",
        title: "Advertisement for the Positions of Junior Research Fellow",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/announcements#OPT_AD_24_01",
        title: "Notification for Outsourced Positions - Physiotherapist",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt.%20IITTCCE2022-2321.pdf",
        title: "Advertisement for the post of Project Manager at CCE",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt%20IITTCSRC2023-2420.pdf",
        title: "Advertisement for the post of Project Associate in a time bound DTH Swayam Prabha Project. (Last date extended up to 31st January, 2024)",
        modal: false,
    }

];

export default announcements2024Array;
